export default __webpack_public_path__ + "static/media/return-packaging-600.7cd6ebb9.jpg";